<template>
  <div style="min-width: 15.75em; border: 0.0625em solid rgba(0, 0, 0, 0.2)">
    <v-progress-linear color="primary" class="ma-0" :indeterminate="loading" />

    <v-list>
      <v-list-tile
        v-for="(item, i) of items"
        :key="i"
        class="align-center px-4 py-2"
      >
        <v-list-tile-content
          style="min-width: 6.25em; border-bottom: 0.0625em solid rgba(0, 0, 0, 0.2)"
        >
          <v-list-tile-title>{{ item }}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action class="align-center" style="flex-flow: row">
          <v-btn style="margin-left: 0.3125em" icon>
            <v-icon color="warning" @click="edit(i)">edit</v-icon>
          </v-btn>

          <v-btn style="margin-left: 0.3125em" icon>
            <v-icon color="error" @click="remove(i)">delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>

      <div v-if="isEditing">
        <!-- New Item Form -->
        <v-text-field
          class="mt-2 px-4 py-2"
          placeholder="Name"
          v-model="newName"
          :error-messages="errors['name']"
        />

        <!-- Submit -->
        <div class="right d-flex mt-2">
          <v-btn small @click="clear">
            <v-icon>close</v-icon>
            <span class="ms-1 hidden-xs-only">Cancel</span>
          </v-btn>

          <v-btn
            v-if="currentIndex === undefined"
            color="primary"
            small
            @click="save"
          >
            <v-icon>check</v-icon>
            <span class="ms-1 hidden-xs-only">Add</span>
          </v-btn>
          <v-btn v-else color="primary" small @click="update">
            <v-icon>check</v-icon>
            <span class="ms-1 hidden-xs-only">Update</span>
          </v-btn>
        </div>
      </div>

      <!-- Add -->
      <v-btn v-else color="primary" class="mt-4 right" small @click="add">
        <v-icon>add</v-icon>
        <span class="ms-1">Add</span>
      </v-btn>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentIndex: undefined,
      newName: undefined,

      isEditing: false,

      errors: {}
    };
  },

  methods: {
    add() {
      this.isEditing = true;
    },

    edit(i) {
      this.isEditing = true;
      this.currentIndex = i;
      this.newName = this.items[i];
    },

    update() {
      if (!this.newName) {
        this.errors = { name: "Please enter name" };
        return;
      }

      this.$emit("edit", this.currentIndex, this.newName);
      this.clear();
    },

    save() {
      if (!this.newName) {
        this.errors = { name: "Please enter name" };
        return;
      }

      this.$emit("add", this.newName);
      this.clear();
    },

    clear() {
      this.isEditing = false;
      this.newName = "";
      this.currentIndex = undefined;
    },

    remove(index) {
      this.$confirm("This will permanently delete item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          this.$emit("remove", index);
        })
        .catch(() => {
          this.$notify({
            type: "info",
            message: "Delete canceled"
          });
        });
    }
  }
};
</script>
